import React, { useState, createContext } from "react";
import { CategoryItem } from "../global/types";

interface CategoriesContextOptions {
  categories: CategoryItem[];
  setCategories: (categories: CategoryItem[]) => void;
  faqCategories: CategoryItem[];
}

export const CategoriesContext = createContext<CategoriesContextOptions>({
  categories: [],
  setCategories: () => [],
  faqCategories: []
});

export const CategoriesProvider: React.FC = ({ children }) => {
  const [categories, setCategoriesState] = useState<CategoryItem[]>([]);
  const [faqCategories, setFaqCategories] = useState<CategoryItem[]>([]);

  const setCategories = (categories: CategoryItem[]) => {
    setFaqCategories(categories.filter(category => category.faq));
    setCategoriesState(categories);
  };

  return (
    <CategoriesContext.Provider
      value={{ categories, setCategories, faqCategories }}
    >
      {children}
    </CategoriesContext.Provider>
  );
};
